"use client";

import { useState, useEffect, useContext, useMemo } from "react";
import { useHistory } from "react-router-dom";
import CartContext from "../../../context/CartContext/CartContext";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Button,
  Badge,
  List,
  ListItem,
  ListItemText,
  TextField,
  InputAdornment,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Chip,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
  Alert,
  Snackbar,
  IconButton,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  ShoppingCart,
  Receipt,
  ClearAll,
  Search,
  PersonAdd,
  Close,
  Person,
  Add,
  Edit,
  Check,
  Cancel,
  Delete,
  Warning,
  PaymentOutlined,
  ArrowForward,
  People,
  Hotel,
  MeetingRoom,
  DateRange,
  EventAvailable,
  EventBusy,
  KingBed,
  SquareFoot,
  FilterList,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonText,
  IonToolbar,
} from "@ionic/react";
import { removeOutline, add as addIcon } from "ionicons/icons";
import axios from "axios";
import {
  getBarInventoryByBranch_hotel,
  getCategories,
} from "../../../api/products/product";
import {  fetchBookedDates } from "../../../api/orders/orders";
import { formatCurrencyN } from "../../../common/utils_t";
import {
  createCustomer,
  getCustomerGrades,
  searchCustomers,
} from "../../../api/customers/customers";
import { baseUrl, config, requestID } from "../../../common/utils";

const StyledProductCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  cursor: "pointer",
  transition: "transform 0.2s",
  "&:hover": {
    transform: "scale(1.02)",
    boxShadow: theme.shadows[4],
  },
}));

const CalendarDay = styled(Paper)(({ theme, available, selected, booked, inCart, disabled }) => ({
  width: 36,
  height: 36,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: (available && !booked && !inCart && !disabled) ? "pointer" : "default",
  backgroundColor: disabled
    ? theme.palette.grey[100]
    : selected 
    ? theme.palette.success.main 
    : inCart
    ? theme.palette.warning.main
    : booked 
    ? theme.palette.error.dark 
    : available 
    ? theme.palette.success.light 
    : theme.palette.grey[300],
  color: disabled 
    ? theme.palette.text.disabled
    : (selected || available || inCart) ? theme.palette.common.white : theme.palette.text.primary,
  "&:hover": {
    backgroundColor: (available && !booked && !inCart && !disabled) ? theme.palette.success.main : undefined,
  },
  opacity: (booked || inCart || disabled) ? 0.6 : 1,
}));

// API function to fetch waiters/stewards (mocked for now)
const getWaiters = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: [],
        status: true,
        message: "Waiters fetched successfully"
      });
    }, 500);
  });
};

const PosPage_hotel_shop_online = () => {
  const history = useHistory();
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const {
    items,
    totalAmount,
    addItem,
    removeItem,
    clearCart,
    updateItemPrice,
  } = useContext(CartContext);
  
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedCustomers, setSearchedCustomers] = useState([]);
  const [customerGrades, setCustomerGrades] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerSearchQuery, setCustomerSearchQuery] = useState("");
  
  // Customer form moved to top - no dialog needed
  const [customerForm, setCustomerForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
  });
  
  const [loading, setLoading] = useState({
    customers: false,
    grades: false,
    products: false,
    availability: false,
  });
  const [processingOrder, setProcessingOrder] = useState(false);
  const [processingPayment, setProcessingPayment] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [useGradePricing, setUseGradePricing] = useState(false);
  const [editingItemId, setEditingItemId] = useState(null);
  const [editPrice, setEditPrice] = useState("");
  const [editPriceError, setEditPriceError] = useState("");

  const [showProcessPaymentDialog, setShowProcessPaymentDialog] = useState(false);
  const [lastOrderCustomer, setLastOrderCustomer] = useState(null);
  const [lastOrderData, setLastOrderData] = useState(null);

  // Hotel room filter states
  const [onlineCategories, setOnlineCategories] = useState([]);
  const [selectedOnlineCategory, setSelectedOnlineCategory] = useState("");
  
  // Booking dialog states - from sample component
  const [showBookingDialog, setShowBookingDialog] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedDates, setSelectedDates] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [roomBookedDates, setRoomBookedDates] = useState({});
  // Guests fixed at 2 per room - removed selection
  
  // Confirmation dialog states - from sample component
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

  const createCustomerOrder_online = async (payload) => {
    const data = {
        requestID: requestID(),...payload
        // data: payload 
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/createCustomerOrder_online",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
  // Helper function to get available quantity for a product
  const getAvailableQuantity = (productId) => {
    const product = allProducts.find(p => p.product_id === productId);
    return product ? product.qty : 0;
  };

  // Helper function to get current cart quantity for a product
  const getCartQuantity = (productId) => {
    const cartItem = items.find(item => item.product_id === productId);
    return cartItem ? cartItem.quantity : 0;
  };

  // Helper function to get remaining available quantity for a product
  const getRemainingQuantity = (productId) => {
    const availableQty = getAvailableQuantity(productId);
    const cartQty = getCartQuantity(productId);
    return Math.max(0, availableQty - cartQty);
  };

  // Get all dates that are already in cart for any room
  const getAllBookedDatesInCart = () => {
    const allDates = new Set();
    items.forEach(item => {
      if (item.selected_dates) {
        item.selected_dates.forEach(date => {
          allDates.add(date);
        });
      }
    });
    return Array.from(allDates);
  };

  // Get dates in cart for a specific room
  const getCartDatesForRoom = (product_id) => {
    const roomItems = items.filter(item => item.product_id === product_id);
    const dates = new Set();
    roomItems.forEach(item => {
      if (item.selected_dates) {
        item.selected_dates.forEach(date => {
          dates.add(date);
        });
      }
    });
    return Array.from(dates);
  };

  // Filter products by selected online category
  const filteredProducts = useMemo(() => {
    if (!Array.isArray(products) || !selectedOnlineCategory) {
      return [];
    }
    return products.filter((product) => {
      const matchesOnlineCategory = product.online_category === selectedOnlineCategory;
      const matchesSearch = product.name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      return matchesOnlineCategory && matchesSearch;
    });
  }, [products, selectedOnlineCategory, searchQuery]);

  const validatePrice = (price, minSalePrice) => {
    const numPrice = Number.parseFloat(price);
    const numMinPrice = Number.parseFloat(minSalePrice);
    if (isNaN(numPrice) || numPrice <= 0) {
      return "Please enter a valid price";
    }
    if (numPrice < numMinPrice) {
      return `Price cannot be less than minimum sale price of ${formatCurrencyN(
        numMinPrice
      )}`;
    }
    return "";
  };

  // Calendar functions - from sample component
  const getDaysInMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };

  const formatDateKey = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const isDateBeforeToday = (date) => {
    const today = new Date();
    const todayKey = formatDateKey(today);
    const dateKey = formatDateKey(date);
    return dateKey < todayKey;
  };

  const isDateDisabled = (date) => {
    return isDateBeforeToday(date);
  };

  const isDateBooked = (date, product_id) => {
    const dateKey = formatDateKey(date);
    const bookedDates = roomBookedDates[product_id];
    return bookedDates?.includes(dateKey);
  };

  const isDateInCart = (date, product_id) => {
    const dateKey = formatDateKey(date);
    const cartDates = getCartDatesForRoom(product_id);
    return cartDates.includes(dateKey);
  };

  const isDateSelected = (date) => {
    const dateKey = formatDateKey(date);
    return selectedDates.includes(dateKey);
  };

  const isDateAvailable = (date, product_id) => {
    return !isDateBooked(date, product_id) && !isDateDisabled(date) && !isDateInCart(date, product_id);
  };

  const handleDateClick = (date) => {
    if (isDateDisabled(date) || !isDateAvailable(date, selectedRoom?.product_id)) {
      return;
    }

    const dateKey = formatDateKey(date);
    setSelectedDates(prev => {
      if (prev.includes(dateKey)) {
        return prev.filter(d => d !== dateKey);
      } else {
        return [...prev, dateKey].sort();
      }
    });
  };

  const generateCalendar = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const daysInMonth = getDaysInMonth(currentMonth);
    const firstDay = getFirstDayOfMonth(currentMonth);
    
    const calendar = [];
    
    for (let i = 0; i < firstDay; i++) {
      calendar.push(null);
    }
    
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      calendar.push(date);
    }
    
    return calendar;
  };

  const navigateMonth = async (direction) => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(currentMonth.getMonth() + direction);
    setCurrentMonth(newMonth);

    if (selectedRoom && showBookingDialog) {
      setLoading(prev => ({ ...prev, availability: true }));
      try {
        const bookedDates = await fetchBookedDates(selectedRoom.product_id, newMonth);
        setRoomBookedDates(prev => ({
          ...prev,
          [selectedRoom.product_id]: bookedDates.data || []
        }));
      } catch (error) {
        console.error("Error fetching booked dates:", error);
      } finally {
        setLoading(prev => ({ ...prev, availability: false }));
      }
    }
  };

  const calculateTotalPrice = () => {
    if (!selectedRoom || selectedDates.length === 0) return 0;
    return selectedRoom.price * selectedDates.length;
  };

  const handleRoomClick = async (room) => {
    if (!validateCustomerForm()) return;
    
    setSelectedRoom(room);
    setSelectedDates([]);
    setCurrentMonth(new Date());
    
    setLoading(prev => ({ ...prev, availability: true }));
    try {
      const bookedDates = await fetchBookedDates(room.product_id, new Date());
      setRoomBookedDates(prev => ({
        ...prev,
        [room.product_id]: bookedDates.data || []
      }));
    } catch (error) {
      console.error("Error fetching booked dates:", error);
    } finally {
      setLoading(prev => ({ ...prev, availability: false }));
    }
    
    setShowBookingDialog(true);
  };

  // MODIFIED: Handle adding booking to cart - UPDATED TO MATCH COMPONENT B BEHAVIOR
  const handleAddBookingToCart = () => {
    if (selectedRoom && selectedDates.length > 0) {
      const nights = selectedDates.length;
      const totalPrice = nights * parseFloat(selectedRoom.price);

      // Check if this room already exists in cart
      const existingItemIndex = items.findIndex(
        item => item.product_id === selectedRoom.product_id && item.is_hotel_booking === true
      );

      if (existingItemIndex >= 0) {
        // Room exists in cart - update it (like Component B)
        const existingItem = items[existingItemIndex];
        
        // Merge the existing dates with new dates
        const allDates = [...new Set([...existingItem.selected_dates, ...selectedDates])].sort();
        const newNights = allDates.length;
        const newTotalPrice = newNights * parseFloat(selectedRoom.price);

        // Create updated item
        const updatedItem = {
          ...existingItem,
          selected_dates: allDates,
          nights: newNights,
          price: newTotalPrice,
          check_in: allDates[0],
          check_out: allDates[allDates.length - 1],
        };

        // Remove old item and add updated one
        removeItem(existingItem.id);
        addItem(updatedItem);

        setSnackbarMessage(`Updated ${selectedRoom.name} booking: now ${newNights} nights`);
      } else {
        // Room doesn't exist in cart - add new item (like Component B)
        const newItem = {
          id: `${selectedRoom.product_id}-${Date.now()}`,
          product_id: selectedRoom.product_id,
          product_name: `${selectedRoom.name} (${nights} nights)`,
          room_name: selectedRoom.name,
          quantity: 1,
          price: totalPrice,
          base_price: selectedRoom.price,
          image: selectedRoom.img_src,
          selected_dates: [...selectedDates],
          nights: nights,
          guests: 2, // Fixed at 2 guests per room
          check_in: selectedDates[0],
          check_out: selectedDates[selectedDates.length - 1],
          is_hotel_booking: true,
        };

        addItem(newItem);
        setSnackbarMessage(`Added ${selectedRoom.name} booking for ${nights} nights`);
      }

      setShowBookingDialog(false);
      setSelectedRoom(null);
      setSelectedDates([]);
      
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
  };

  const handleEditItemPrice = (itemId, currentPrice, minSalePrice) => {
    setEditingItemId(itemId);
    setEditPrice(currentPrice.toString());
    setEditPriceError("");
  };

  const handleEditPriceChange = (value, minSalePrice) => {
    setEditPrice(value);
    const error = validatePrice(value, minSalePrice);
    setEditPriceError(error);
  };

  const handleSaveEditPrice = (itemId, minSalePrice) => {
    const error = validatePrice(editPrice, minSalePrice);
    if (error) {
      setEditPriceError(error);
      return;
    }
    if (editPrice && updateItemPrice) {
      updateItemPrice(itemId, Number.parseFloat(editPrice));
      setSnackbarMessage("Price updated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
    setEditingItemId(null);
    setEditPrice("");
    setEditPriceError("");
  };

  const handleCancelEditPrice = () => {
    setEditingItemId(null);
    setEditPrice("");
    setEditPriceError("");
  };

  const fetchInitialData = async () => {
    try {
      setLoading((prev) => ({ ...prev, products: true, grades: true }));
      const [productsRes, categoriesRes, gradesRes] = await Promise.all([
        getBarInventoryByBranch_hotel(),
        getCategories(),
        getCustomerGrades(),
      ]);

      const productsWithCategoryName = productsRes.data.map(p => {
        const category = categoriesRes.data.find(c => c.category_id === p.productCategory);
        return { ...p, category: category ? category.name : 'Unknown' };
      });

      setAllProducts(productsWithCategoryName);
      setProducts(productsWithCategoryName);
      setCategories(categoriesRes.data);
      setCustomerGrades(gradesRes.data);
      
      // Extract unique online categories
      const uniqueCategories = [...new Set(productsRes.data
        .map(p => p.online_category)
        .filter(cat => cat && cat.trim() !== "")
      )];
      setOnlineCategories(uniqueCategories);
      
    } catch (error) {
      console.error("Error fetching initial data:", error);
      setSnackbarMessage("Failed to load initial data.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading((prev) => ({ ...prev, products: false, grades: false }));
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (useGradePricing) {
      if (!selectedCustomer || !selectedCustomer.customer_grade) {
        setProducts([]);
        return;
      }
      const gradeId = selectedCustomer.customer_grade;
      const filtered = allProducts.filter(
        (product) =>
          product.grade_ids?.includes(gradeId) ||
          product.grade_id === gradeId ||
          !product.grade_id
      );
      setProducts(filtered);
    } else {
      setProducts(allProducts);
    }
  }, [selectedCustomer, allProducts, useGradePricing]);

  const validateCustomerForm = () => {
    // Check if customer form is filled
    if (!customerForm.firstName || !customerForm.lastName || !customerForm.phone) {
      setSnackbarMessage("Please fill in customer details (Name and Phone are required).");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return false;
    }
    
    return true;
  };

  const handleCreateCustomerFromForm = async () => {
    try {
      const customerData = {
        firstName: customerForm.firstName,
        lastName: customerForm.lastName,
        phone: customerForm.phone,
        email: customerForm.email,
        grade: "A",
      };

      const response = await createCustomer(customerData);
      setSelectedCustomer(response.data);
      return response.data;
    } catch (error) {
      console.error("Error creating customer:", error);
      setSnackbarMessage("Failed to create customer. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return null;
    }
  };

  const onHandleCreateOrder = async () => {
    if (!customerForm.firstName || !customerForm.lastName || !customerForm.phone) {
      setSnackbarMessage("Please fill in customer details.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setProcessingOrder(true);
    
    // Create customer first
    let customer = selectedCustomer;
    if (!customer) {
      customer = await handleCreateCustomerFromForm();
      if (!customer) {
        setProcessingOrder(false);
        return;
      }
    }
    
    const saleData = {
      customer_id: customer?.user_id || null,
      customer_name: `${customerForm.firstName} ${customerForm.lastName}`,
      customer_email: customerForm.email,
      customer_phone: customerForm.phone,
      items: items.map(item => ({
        ...item,
        selected_dates: item.selected_dates,
        nights: item.nights,
        guests: 2, // Fixed at 2 guests per room
      })),
      totalPrice: totalAmount,
      paymentType: "cash",
      amountPaid: totalAmount,
      changeGiven: 0,
      pricing_mode: useGradePricing ? "grade" : "manual",
      booking_type: "online_booking",
      business_id: "bus_id_470fa0bc1c4ea4446e1be0ce31aa8018",
      branch_id: "bra_id_c91c3049f001472749851911045d31ff"
    };

    try {
      const res = await createCustomerOrder_online(saleData);
      console.log("Order creation response:", res);

      if (res.status === true) {
        setSnackbarMessage("Booking created successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setLastOrderCustomer(customer);

        console.log("Order creation response:", res.orderId);
        setLastOrderData({
          orderId: res?.orderId || "0",
          orderReference: res?.orderReference || "",
          totalAmount: totalAmount,
          customer: customer
        });
        setShowConfirmationDialog(false);
        setShowProcessPaymentDialog(true);
        // Don't clear cart yet - we'll clear after payment
      } else {
        setSnackbarMessage("Failed to create booking." + (res.message || ""));
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error creating booking:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Failed to create booking. Please try again.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setProcessingOrder(false);
    }
  };

  // Payment function
  const startPayment = async () => {
    if (!lastOrderCustomer || !lastOrderData) {
      setSnackbarMessage("No order data found for payment");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setProcessingPayment(true);
    
    try {
      // Generate a unique transaction code
      const tcode = `HOTEL-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
      
      const recipientx = {
        Currency: "NGN",
        MerchantRef: tcode,
        Amount: totalAmount,
        Description: `Hotel Booking - ${items.length} room(s)`,
        CustomerId: lastOrderCustomer?.user_id || customerForm.phone,
        CustomerName: `${customerForm.firstName} ${customerForm.lastName}`,
        CustomerEmail: customerForm.email || "guest@example.com",
        CustomerMobile: customerForm.phone,
        IntegrationKey: "bb1fef9479604181aa84ebdd980a7ec5",
        ProductCode: "HOTEL_BOOKING",
        progID: "hotel",
        session: new Date().getFullYear().toString(),
        levelID: "1"
      };

      console.log("Payment request data:", recipientx);
      console.log("Payment request data:", lastOrderData);

      // Call your backend makePayment API
      const paymentRes = await axios.post(baseUrl() + "/orderhistorys/makePayment", {
        email: customerForm.email || "guest@example.com",
        amount: totalAmount,
        gheliValue: 0,
        schValue: totalAmount,
        tcode: lastOrderData.orderId,
        requestID: requestID(),
      }, config);

      console.log("Payment response:", paymentRes.data);

      const paymentResult = paymentRes.data;

      if (!paymentResult?.data?.checkoutLink) {
        alert("Payment initialization failed");
        setProcessingPayment(false);
        return;
      }

      const refx = paymentResult.data.orderReference;

      alert("Copy Your Ref. Code: " + refx);

      // Save transaction data
      const keepResponse = await axios.get("/api/keep", {
        params: {
          myDatax: encodeURIComponent(JSON.stringify(recipientx)),
          ref: refx
        }
      });
      
      console.log("Keep API response:", keepResponse.data);

      // Clear cart after successful payment initiation
      clearCart();
      setCustomerForm({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
      });
      
      // Redirect to Nomba checkout
      window.location.href = paymentResult.data.checkoutLink;

    } catch (error) {
      console.error("Payment error:", error);
      if (error.response) {
        console.error("Payment error response:", error.response.data);
      }
      alert("Transaction Failed! Check console for details.");
    } finally {
      setProcessingPayment(false);
      setShowProcessPaymentDialog(false);
    }
  };

  const cartItemRemoveHandler = (id) => {
    removeItem(id);
    setSnackbarMessage("Item removed from cart");
    setSnackbarSeverity("info");
    setSnackbarOpen(true);
  };

  return (
    <IonPage>
      <IonContent>
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            bgcolor: "#f5f7fa",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              p: 2,
              bgcolor: "#667eea",
              color: "white",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 700 }}>
                Hotel Online Booking System
              </Typography>
            </Box>
          </Box>

          {/* Main Content */}
          <Box sx={{ flex: 1, display: "flex", overflow: "hidden" }}>
            {/* Left Panel - Customer Form and Room Selection */}
            <Box
              sx={{
                width: { xs: "100%", md: "70%" },
                p: 2,
                overflowY: "auto",
                borderRight: { md: "1px solid #e0e0e0" },
              }}
            >
              {/* Customer Form - Moved to top */}
              <Paper sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                  Customer Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="First Name *"
                      size="small"
                      value={customerForm.firstName}
                      onChange={(e) => setCustomerForm({ ...customerForm, firstName: e.target.value })}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Person />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Last Name *"
                      size="small"
                      value={customerForm.lastName}
                      onChange={(e) => setCustomerForm({ ...customerForm, lastName: e.target.value })}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Phone Number *"
                      size="small"
                      value={customerForm.phone}
                      onChange={(e) => setCustomerForm({ ...customerForm, phone: e.target.value })}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      size="small"
                      type="email"
                      value={customerForm.email}
                      onChange={(e) => setCustomerForm({ ...customerForm, email: e.target.value })}
                    />
                  </Grid>
                </Grid>
              </Paper>

              {/* Room Type Filter */}
              <Paper sx={{ p: 2, mb: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                  Select Room Type
                </Typography>
                <FormControl fullWidth>
                  <Select
                    value={selectedOnlineCategory}
                    onChange={(e) => setSelectedOnlineCategory(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="">
                      <em>Select a room type to view rooms</em>
                    </MenuItem>
                    {onlineCategories.map((category) => (
                      <MenuItem key={category} value={category}>
                        {category}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Paper>

              {/* Search Bar */}
              {selectedOnlineCategory && (
                <TextField
                  fullWidth
                  placeholder={`Search rooms in ${selectedOnlineCategory}...`}
                  variant="outlined"
                  size="small"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ mb: 2 }}
                />
              )}

              {/* Room Grid */}
              {loading.products ? (
                <Grid container spacing={2}>
                  {Array.from({ length: 8 }).map((_, index) => (
                    <Grid item xs={6} sm={4} md={3} key={index}>
                      <StyledProductCard
                        sx={{
                          height: 200,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CircularProgress size={40} sx={{ mb: 2 }} />
                        <Typography variant="subtitle1">
                          Loading...
                        </Typography>
                      </StyledProductCard>
                    </Grid>
                  ))}
                </Grid>
              ) : !selectedOnlineCategory ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "300px",
                    textAlign: "center",
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    p: 4,
                  }}
                >
                  <Hotel sx={{ fontSize: 80, color: "text.disabled", mb: 2 }} />
                  <Typography variant="h6" color="text.secondary" gutterBottom>
                    No Room Type Selected
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Please select a room type from the dropdown above to view available rooms.
                  </Typography>
                </Box>
              ) : filteredProducts?.length > 0 ? (
                <Grid container spacing={2}>
                  {filteredProducts.map((product, i) => (
                    <Grid item xs={6} sm={4} md={3} key={i}>
                      <StyledProductCard
                        onClick={() => handleRoomClick(product)}
                        sx={{
                          opacity: product.qty <= 0 ? 0.5 : 1,
                          cursor: product.qty <= 0 ? 'not-allowed' : 'pointer',
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Avatar
                            src={
                              product.img_src ||
                              "/placeholder.svg?height=80&width=80&query=hotel+room"
                            }
                            alt={product.name}
                            sx={{ width: 80, height: 80, mb: 1 }}
                          />
                          <Typography
                            variant="subtitle1"
                            align="center"
                            sx={{ fontWeight: 600 }}
                          >
                            {product.name}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                          >
                            {product.type || 'Standard Room'}
                          </Typography>
                          <Typography
                            variant="h6"
                            color="primary"
                            sx={{ mt: 1, fontWeight: 600 }}
                          >
                            {formatCurrencyN(product.price)}/night
                          </Typography>
                          <Chip
                            label={`Capacity: 2 people`}
                            size="small"
                            color="secondary"
                            sx={{ mt: 1 }}
                          />
                          {product.qty <= 0 && (
                            <Chip
                              label="Out of Stock"
                              size="small"
                              color="error"
                              sx={{ mt: 1 }}
                            />
                          )}
                        </Box>
                      </StyledProductCard>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Box sx={{ textAlign: "center", p: 4 }}>
                  <Typography variant="h6" color="text.secondary">
                    No rooms found in {selectedOnlineCategory}
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Right Panel - Cart */}
            <Box
              sx={{
                width: { xs: "100%", md: "30%" },
                display: "flex",
                flexDirection: "column",
                bgcolor: "background.paper",
                boxShadow: { xs: "0 -4px 12px rgba(0,0,0,0.1)", md: "none" },
              }}
            >
              <Box
                sx={{
                  p: 2,
                  bgcolor: "background.paper",
                  borderBottom: "1px solid #e0e0e0",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  <Badge
                    badgeContent={items.length}
                    color="primary"
                    sx={{ mr: 1 }}
                  >
                    <ShoppingCart />
                  </Badge>
                  Current Bookings
                </Typography>
                <Button
                  size="small"
                  color="error"
                  startIcon={<ClearAll />}
                  onClick={clearCart}
                  disabled={items.length === 0}
                  sx={{ borderRadius: 2, textTransform: "none" }}
                >
                  Clear
                </Button>
              </Box>
              
              <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
                {items.length === 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      textAlign: "center",
                      py: 4,
                    }}
                  >
                    <ShoppingCart
                      sx={{ fontSize: 64, color: "text.disabled", mb: 1 }}
                    />
                    <Typography variant="body1" color="text.secondary">
                      No bookings yet
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Select a room type and room to book
                    </Typography>
                  </Box>
                ) : (
                  <List dense>
                    {items.map((item, i) => (
                      <ListItem
                        key={`${item.id}-${i}`}
                        sx={{
                          py: 1,
                          flexDirection: "column",
                          alignItems: "stretch",
                          borderBottom: "1px dashed #eee",
                          "&:last-child": { borderBottom: "none" },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            width: "100%",
                          }}
                        >
                          <Avatar
                            src={
                              item?.image ||
                              "/placeholder.svg?height=40&width=40&query=hotel"
                            }
                            alt={item.room_name || item.product_name}
                            sx={{ width: 40, height: 40, mr: 2 }}
                          />
                          <Box sx={{ flex: 1 }}>
                            <Typography
                              variant="subtitle2"
                              sx={{ fontWeight: 600 }}
                            >
                              {item.room_name || item.product_name}
                            </Typography>
                            {item.is_hotel_booking && (
                              <>
                                <Typography variant="body2" color="text.secondary">
                                  {item.nights} night(s) • 2 guests
                                </Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                  {item.check_in} to {item.check_out}
                                </Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                  Dates: {item.selected_dates?.join(', ')}
                                </Typography>
                              </>
                            )}
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 600, color: "primary.main" }}
                            >
                              {formatCurrencyN(item.price)}
                            </Typography>
                          </Box>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => cartItemRemoveHandler(item.id)}
                          >
                            <Close />
                          </IconButton>
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                )}
              </Box>

              {/* Booking Summary */}
              <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0', bgcolor: 'background.paper' }}>
                <Box sx={{ mb: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Total Amount:</Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#667eea' }}>
                      {formatCurrencyN(totalAmount)}
                    </Typography>
                  </Box>
                </Box>

                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={() => setShowConfirmationDialog(true)}
                  startIcon={<Receipt />}
                  sx={{
                    bgcolor: "#667eea",
                    color: "white",
                    "&:hover": { bgcolor: "#5a6fd8" },
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    py: 1.5,
                  }}
                  disabled={items.length === 0}
                >
                  Review Booking
                </Button>
              </Box>
            </Box>
          </Box>

          {/* Room Booking Dialog */}
          <Dialog
            open={showBookingDialog}
            onClose={() => setShowBookingDialog(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle sx={{ pb: 1 }}>
              Book Room
              <IconButton
                sx={{ position: "absolute", right: 8, top: 8 }}
                onClick={() => setShowBookingDialog(false)}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {selectedRoom && (
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <Avatar
                      src={
                        selectedRoom.img_src ||
                        "/placeholder.svg?height=60&width=60&query=room"
                      }
                      alt={selectedRoom.name}
                      sx={{ width: 60, height: 60, mr: 2 }}
                    />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {selectedRoom.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {selectedRoom.type || 'Standard Room'}
                      </Typography>
                      <Typography variant="h6" color="primary">
                        {formatCurrencyN(selectedRoom.price)}/night
                      </Typography>
                    </Box>
                  </Box>
                  
                  <Divider sx={{ my: 2 }} />
                  
                  {/* Availability Calendar */}
                  <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, textAlign: 'center' }}>
                    Select Available Dates
                  </Typography>
                  
                  {loading.availability && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                      <CircularProgress size={24} />
                      <Typography variant="body2" sx={{ ml: 1 }}>
                        Loading availability...
                      </Typography>
                    </Box>
                  )}
                  
                  <Box sx={{ mb: 2, p: 1, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                    {/* Calendar Header */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                      <Button onClick={() => navigateMonth(-1)} size="small">‹</Button>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {currentMonth.toLocaleString('default', { month: 'long', year: 'numeric' })}
                      </Typography>
                      <Button onClick={() => navigateMonth(1)} size="small">›</Button>
                    </Box>

                    {/* Day Headers */}
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 0.5, mb: 1 }}>
                      {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(day => (
                        <Box key={day} sx={{ textAlign: 'center' }}>
                          <Typography variant="caption" sx={{ fontWeight: 600 }}>
                            {day}
                          </Typography>
                        </Box>
                      ))}
                    </Box>

                    {/* Calendar Days */}
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 0.5 }}>
                      {generateCalendar().map((date, index) => (
                        <Box key={index} sx={{ display: 'flex', justifyContent: 'center' }}>
                          {date ? (
                            <CalendarDay
                              available={isDateAvailable(date, selectedRoom.product_id)}
                              booked={isDateBooked(date, selectedRoom.product_id)}
                              inCart={isDateInCart(date, selectedRoom.product_id)}
                              disabled={isDateDisabled(date)}
                              selected={isDateSelected(date)}
                              onClick={() => handleDateClick(date)}
                              sx={{
                                width: 32,
                                height: 32,
                                minWidth: 32,
                                fontSize: '0.75rem',
                                borderRadius: 1
                              }}
                            >
                              {date.getDate()}
                            </CalendarDay>
                          ) : (
                            <Box sx={{ width: 32, height: 32 }} />
                          )}
                        </Box>
                      ))}
                    </Box>
                  </Box>

                  {/* Legend */}
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5, mb: 2, flexWrap: 'wrap' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Box sx={{ width: 12, height: 12, backgroundColor: 'success.light', borderRadius: '1px' }} />
                      <Typography variant="caption">Available</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Box sx={{ width: 12, height: 12, backgroundColor: 'success.main', borderRadius: '1px' }} />
                      <Typography variant="caption">Selected</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Box sx={{ width: 12, height: 12, backgroundColor: 'warning.main', borderRadius: '1px', opacity: 0.6 }} />
                      <Typography variant="caption">In Cart</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Box sx={{ width: 12, height: 12, backgroundColor: 'error.dark', borderRadius: '1px', opacity: 0.6 }} />
                      <Typography variant="caption">Booked</Typography>
                    </Box>
                  </Box>

                  {/* Guest information */}
                  <Alert severity="info" sx={{ mb: 2 }}>
                    <Typography variant="body2">This room accommodates up to 2 guests</Typography>
                  </Alert>

                  {/* Booking Summary */}
                  {selectedDates.length > 0 && (
                    <Alert severity="success" sx={{ mb: 1 }}>
                      <Box>
                        <div><strong>{selectedDates.length} night(s) selected</strong></div>
                        <div>Check-in: {selectedDates[0]}</div>
                        <div>Check-out: {selectedDates[selectedDates.length - 1]}</div>
                        <div><strong>Total: {formatCurrencyN(calculateTotalPrice())}</strong></div>
                      </Box>
                    </Alert>
                  )}
                </Box>
              )}
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={() => setShowBookingDialog(false)}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleAddBookingToCart}
                disabled={selectedDates.length === 0}
                startIcon={<Add />}
                sx={{ bgcolor: "#667eea" }}
              >
                {items.some(item => item.product_id === selectedRoom?.product_id && item.is_hotel_booking) 
                  ? "Update Booking" 
                  : "Add to Cart"} ({selectedDates.length} nights)
              </Button>
            </DialogActions>
          </Dialog>

          {/* Booking Confirmation Dialog */}
          <Dialog
            open={showConfirmationDialog}
            onClose={() => setShowConfirmationDialog(false)}
            maxWidth="lg"
            fullWidth
          >
            <DialogTitle sx={{ pb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Check sx={{ color: 'success.main' }} />
              Confirm Booking Details
              <IconButton
                sx={{ position: "absolute", right: 8, top: 8 }}
                onClick={() => setShowConfirmationDialog(false)}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {/* Customer Information */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: 'primary.main' }}>
                  Customer Information
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
                  <Avatar sx={{ bgcolor: 'primary.main' }}>
                    <Person />
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      {customerForm.firstName} {customerForm.lastName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {customerForm.phone} • {customerForm.email || 'No email'}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Divider sx={{ my: 2 }} />

              {/* Booking Summary */}
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: 'primary.main' }}>
                Booking Summary
              </Typography>
              
              <TableContainer component={Paper} variant="outlined">
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: 'grey.50' }}>
                      <TableCell sx={{ fontWeight: 600 }}>Room</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Dates</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Nights</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Guests</TableCell>
                      <TableCell sx={{ fontWeight: 600 }} align="right">Price/Night</TableCell>
                      <TableCell sx={{ fontWeight: 600 }} align="right">Total</TableCell>
                      <TableCell sx={{ fontWeight: 600 }} align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items.map((item, index) => (
                      <TableRow key={`${item.id}-${index}`}>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar
                              src={item.image}
                              alt={item.room_name || item.product_name}
                              sx={{ width: 40, height: 40 }}
                            />
                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                              {item.room_name || item.product_name}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {item.check_in} to {item.check_out}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {item.nights}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            2
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography variant="body2">
                            {formatCurrencyN(item.base_price)}
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {formatCurrencyN(item.price)}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip title="Remove this booking">
                            <IconButton 
                              color="error" 
                              onClick={() => cartItemRemoveHandler(item.id)}
                              size="small"
                            >
                              <Delete />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                    
                    {/* Total Row */}
                    <TableRow>
                      <TableCell colSpan={5} align="right" sx={{ border: 'none', pt: 2 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          Total Amount:
                        </Typography>
                      </TableCell>
                      <TableCell align="right" sx={{ border: 'none', pt: 2 }}>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main' }}>
                          {formatCurrencyN(totalAmount)}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ border: 'none' }}></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              {items.length === 0 ? (
                <Alert severity="warning" sx={{ mt: 2 }}>
                  Your cart is empty. Please add some bookings before proceeding.
                </Alert>
              ) : (
                <Alert severity="info" sx={{ mt: 2 }}>
                  Please review all booking details carefully before proceeding.
                </Alert>
              )}
            </DialogContent>
            <DialogActions sx={{ p: 3, gap: 1 }}>
              <Button
                onClick={() => setShowConfirmationDialog(false)}
                startIcon={<Cancel />}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={onHandleCreateOrder}
                disabled={processingOrder || items.length === 0}
                startIcon={processingOrder ? <CircularProgress size={20} /> : <Check />}
                sx={{ bgcolor: "success.main", "&:hover": { bgcolor: "success.dark" } }}
              >
                {processingOrder ? "Processing..." : "Confirm Booking"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Process Payment Dialog */}
          <Dialog open={showProcessPaymentDialog} onClose={() => setShowProcessPaymentDialog(false)}>
            <DialogTitle>Process Payment</DialogTitle>
            <DialogContent>
              <Typography>Do you want to process payment for this customer?</Typography>
            </DialogContent>
            <DialogActions>
              <Button 
                onClick={() => {
                  setShowProcessPaymentDialog(false);
                  // Clear cart if user chooses not to pay
                  clearCart();
                  setCustomerForm({
                    firstName: "",
                    lastName: "",
                    phone: "",
                    email: "",
                  });
                }}
              >
                No
              </Button>
              <Button 
                onClick={startPayment}
                disabled={processingPayment}
                startIcon={processingPayment ? <CircularProgress size={20} /> : <PaymentOutlined />}
                variant="contained"
                color="primary"
              >
                {processingPayment ? "Processing..." : "Yes, Pay Now"}
              </Button>
            </DialogActions>
          </Dialog>

          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={() => setSnackbarOpen(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              onClose={() => setSnackbarOpen(false)}
              severity={snackbarSeverity}
              sx={{ width: "100%" }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default PosPage_hotel_shop_online;